import { SAMPLE_TRIP } from "./fixtures";

/** Mock of a day-by-day timeline with stops. */
export function TimelinePreview() {
  return (
    <div className="w-full h-full p-3 overflow-hidden">
      <div className="relative pl-5">
        {/* Vertical thread */}
        <div className="absolute left-2 top-2 bottom-2 w-px bg-[var(--roava-border)]" />
        {SAMPLE_TRIP.pods.map((pod, i) => (
          <div key={pod.id} className="relative mb-3 last:mb-0">
            <div className="absolute -left-3 top-1.5 size-3 rounded-full bg-[var(--roava-blue)] ring-2 ring-[var(--roava-bg-elev)]" />
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center rounded-full bg-[var(--roava-blue)]/10 text-[var(--roava-blue)] text-[10px] font-semibold px-1.5 py-0.5">
                Day {i < 2 ? 1 : 2}
              </span>
              <p className="text-[12px] font-semibold text-[var(--roava-text)] truncate">{pod.placeName}</p>
            </div>
            <p className="text-[10px] text-[var(--roava-text-muted)] mt-0.5">{pod.timeLabel}</p>
            <div className="flex gap-1 mt-1.5">
              {pod.photos.slice(0, 3).map((p) => (
                <div key={p.id} className="size-9 rounded-md overflow-hidden bg-[var(--roava-border)]">
                  <img src={p.url} alt="" className="w-full h-full object-cover" loading="lazy" draggable={false} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
